function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgDonationsTwitch = function SvgDonationsTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 144 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.7433L0 1.12134L10.4071 1.12134L15.3245 7.68899L43.7843 7.68899V1.12134L64.5126 1.12134V7.68899H70.9324V10.4363L73.7036 7.68899H81.8213L86.6426 1.12134L97.0553 1.12134V7.68899H101.805L106.542 12.415V28.3803L98.0254 36.8786H74.4334L70.9383 33.3868V36.8786H58.6311L55.2061 33.4535V36.8786H29.9193L26.2706 33.2299V36.8786H13.1353L0 23.7433ZM45.9007 3.31038H53.198V7.68882H45.9007V3.31038ZM45.9007 9.87823H53.1981V26.4115H45.9007V9.87823ZM2.18868 3.31068L2.18868 22.8423L5.83738 26.4036H15.9319V18.9765H9.48607V17.0696H15.9319V9.87834H9.48607V3.31068H2.18868ZM17.8849 22.7291V9.87834H25.2893V18.9958H27.2325V9.87834H34.6435V18.9869H36.4869V9.87834H43.7843V26.4038H21.567L17.8849 22.7291ZM62.2716 3.31046L55.1953 3.31046V22.7622L58.8215 26.4227H69.0421V18.9887H62.2716V17.0705H69.052V9.87823H62.2716V3.31046ZM70.9177 13.527L74.4338 9.87834L85.7663 9.87834V17.0776H78.3512V18.9978H85.7663V26.403H74.6659L70.9177 22.6346V13.527ZM95.0605 3.31057H87.6614V26.4H95.0708V17.0797H97.0536V26.4H104.351V13.5269L100.702 9.87822H95.0605V3.31057Z",
    fill: "#6B6B70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.323 17.7903L132.484 22.6296H127.643L123.408 26.8646V22.6296H117.963V4.47988H137.323V17.7903ZM116.753 2.06021L110.703 8.11051V29.8886H117.963V35.9389L124.014 29.8886H128.853L139.744 18.999V2.05908L116.753 2.06021ZM131.274 8.71486H133.693V15.975H131.274V8.71486ZM124.618 8.71486H127.039V15.975H124.617L124.618 8.71486Z",
    fill: "#6B6B70"
  }));
};
export default SvgDonationsTwitch;